import { Grid } from "@mui/material";
import { Box, styled } from "@mui/system";

import colors from "../../styles/colors/colors";

export const LogoutLayout = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
  boxSizing: "border-box",
  padding: "2rem 1.5rem",
}));

export const LogoutCard = styled(Box)(() => ({
  width: "100%",
  minHeight: "12rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: colors.white[1],
  borderRadius: "0.5rem",
  boxShadow: `0.1rem 0.1rem 0.3rem ${colors.dropShadow[1]}`,
}));